import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'quotaStatus',
  standalone: true,
  pure: false
})
export class QuotaStatusPipe implements PipeTransform {
  private translate = inject(TranslateService);

  private statusKeyMap: Record<string, string> = {
    'ACTIVE': 'quotaStatusDialog.statuses.active',
    'COMPLETED': 'quotaStatusDialog.statuses.completed',
    'EXPIRED': 'quotaStatusDialog.statuses.expired',
    'USED': 'quotaStatusDialog.statuses.used',
  };

  transform(status: string): string {
    const key = this.statusKeyMap[status];
    return key ? this.translate.instant(key) : status;
  }
}
